
import React, { useEffect, useRef } from 'react'
import { OrbitControls } from '@react-three/drei';

import { const_var, params } from '../../../redux/reducers/reducer';

const CanvasEnv = () => {
    const orbitCam = useRef();
    
    useEffect(() => {
      if (orbitCam !== undefined) {
        if (orbitCam.current !== undefined) {
            const_var.controls = orbitCam.current;
        }
      }
    }, [orbitCam])

    return (
        <>        
            <OrbitControls
                key={true}
                ref={orbitCam}
                maxPolarAngle={Infinity}
                minAzimuthAngle={-Infinity}
                maxAzimuthAngle={Infinity}
                minDistance={1}
                maxDistance={600}
                rotateSpeed={0.4}
                zoomSpeed={1}
                panSpeed={0.8}
                enableZoom={true}
                enablePan={true}
                enableDamping={false}
                dampingFactor={0.08}
                makeDefault
            />
            <ambientLight intensity={1} />
            <directionalLight position={[-params.p_w / 2 - 10, params.p_h / 1.5, params.p_d / 2 + 10]} intensity={0.1} />
            <directionalLight position={[params.p_w / 2 + 10, params.p_h / 1.5, -params.p_d / 2 - 10]} intensity={0.1} />
            <directionalLight position={[-params.p_w / 2 - 10, params.p_h / 1.5, -params.p_d / 2 - 10]} intensity={0.1} />
            <directionalLight position={[params.p_w / 2 + 10, params.p_h / 1.5, params.p_d / 2 + 10]} intensity={0.1} />
            <hemisphereLight color="white" groundColor="gray" intensity={4} position={[0,params.p_h,0]}/>
        </>
    )
}

export default CanvasEnv